/**
 * 复制文字
 *
 * @param value
 * @example
 *
 * copy('somestring')
 * // 'somestring'
 */
function copy(value: string) {
  const input = document.createElement('input');
  document.body.appendChild(input);
  input.setAttribute('value', value);
  input.select();
  const copyLine = document.execCommand('copy');
  document.body.removeChild(input);
  return copyLine;
}

export { copy };
